import { FC } from "react";

const NotFoundPage: FC = () => {
  return <div>NotFound</div>;
};

export default NotFoundPage;
